module.exports = __webpack_public_path__ + "img/icon_info_kepegawaian.30012376.svg";